/**
 * User type definition
 * @typedef {Object} ComponentsExport
 * @property {import('react').FC<any>} Button
 * @property {import('react').FC<any>} ButtonGroup
 * @property {import('react').FC<any>} Checkbox
 * @property {import('react').FC<any>} ContextMenu
 * @property {import('react').FC<any>} Heading
 * @property {import('react').FC<any>} Paragraph
 * @property {import('react').FC<any>} Label
 * @property {Function} useDialogState
 * @property {Function} useListState
 * @property {import('react').FC<any>} Dialog
 * @property {import('react').FC<any>} DialogBody
 * @property {import('react').FC<any>} DialogFooter
 * @property {import('react').FC<any>} DialogHeader
 * @property {import('react').FC<any>} DialogTrigger
 * @property {import('react').FC<any>} ConfirmationDialog
 * @property {import('react').VF} CopyToClipboard
 * @property {import('react').FC<any>} DatePicker
 * @property {import('react').VF} ColorPicker
 * @property {import('react').VF} ColorPreview
 * @property {import('react').VF} InputColorPicker
 * @property {Function} useDropdownState
 * @property {import('react').FC<any>} Dropdown
 * @property {import('react').FC} DropdownBar
 * @property {import('react').FC<any>} DropdownItem
 * @property {import('react').FC} DropdownSeparator
 * @property {import('react').FC} MoreButtonDropdown
 * @property {import('react').Context<any>} DropdownContext
 * @property {import('react').FC} GridLayout
 * @property {import('react').FC<any>} ChartGrid
 * @property {import('react').FC} ChartGridCell
 * @property {any} IconName
 * @property {import('react').FC<any>} Icon
 * @property {import('react').FC} Logo
 * @property {import('react').FC} CircleLogo
 * @property {any} InputTheme
 * @property {import('react').FC<any>} Input
 * @property {import('react').FC<any>} InnerState
 * @property {import('react').FC<any>} TooltipInput
 * @property {import('react').FC<any>} Textarea
 * @property {import('react').FC} HighlightedResult
 * @property {import('react').FC<any>} ListItem
 * @property {import('react').FC<any>} List
 * @property {import('react').FC} CategoryList
 * @property {Function} searchByValue
 * @property {Function} sortByLabel
 * @property {Function} useListSearch
 * @property {Function} usePopoverState
 * @property {import('react').FC} PopoverTrigger
 * @property {import('react').FC} Popover
 * @property {import('react').VF} RangeSlider
 * @property {import('react').FC} TickerSearch
 * @property {import('react').FC<any>} Select
 * @property {import('react').FC<any>} SelectOption
 * @property {import('react').FC<any>} Spinner
 * @property {import('react').FC<any>} Delayed
 * @property {import('react').FC} ColorSelect
 * @property {import('react').FC<any>} Toolbar
 * @property {import('react').FC<any>} ToolbarItem
 * @property {import('react').FC<any>} ToolbarDivider
 * @property {any} DrawingTool
 * @property {Function} useTooltipState
 * @property {import('react').FC<any>} Tooltip
 * @property {import('react').FC<any>} TooltipTrigger
 * @property {Function} useTour
 * @property {import('react').FC} Paragraph
 * @property {import('react').FC<any>} ButtonColorPicker
 * @property {import('react').FC<any>} InnerState
 * @property {import('react').FC<any>} TimeframeBar
 * @property {Function} convertColorToHEX
 * @property {Function} hexStringToRGBA
 * @property {Function} rgbaToRGBAString
 * @property {Function} withNotificationContext
 * @property {Function} useNotification
 * @property {import('react').FC<any>} Notification
 * @property {import('react').FC<any>} NotificationWrapper
 * @property {import('react').FC<any>} Time
 */

/**
 * Add type so that the properties are suggested
 * @type {ComponentsExport}
 */
const componentsLib = window.FLibs.components

module.exports = componentsLib
